/* eslint-disable unicorn/numeric-separators-style */
import React from 'react';
import { GetStaticPropsContext, NextPage } from 'next';
import MyHead from '../../../components/MyHead';

import Footer from '../../../components/Footer';
import ShopCard from '../../../components/ShopCard';
import Menu from '../../../components/Menu/Menu';
import BannerShipping from '../../../components/BannerShipping';

import { LANG_STATIC_PATHS } from '../../../helpers/staticPaths';
import { SUPPORTED_COUNTRY } from '../../../helpers/countries';
import {
  getLangCountry,
  getRealLangCountry,
  SUPPORTED_LANG
} from '../../../helpers/languages';
import { getShopContent } from '../../../fetchers/shop';
import { IShopData } from '../../../models/shop';

import { fetchAlternateUrls } from '../../../fetchers/commons';
import { AlternateLangs } from '../../../models/app';
import { useTranslation } from 'react-i18next';

interface IShopPage {
  data: IShopData;
  alternates: AlternateLangs[];
}

const Shop: NextPage<IShopPage> = ({ data, alternates }) => {
  const { t } = useTranslation();

  return (
    <>
      <MyHead
        title={t('SHOP_TITLE')}
        description={t('SHOP_DESCRIPTION')}
        alternates={alternates}
      />
      <div>
        {/* <BannerShipping /> */}
        <Menu />

        <div className="grid grid-cols-1 gap-6 p-6 lg:grid-cols-2">
          {data?.content
            ?.sort((a, b) => a.order - b.order)
            .map(({ image, title, buttons = [] }, idx) => (
              <ShopCard
                key={idx}
                title={title}
                image={image}
                buttons={buttons}
              />
            ))}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Shop;

export async function getStaticProps(context: GetStaticPropsContext) {
  const { params } = context;
  const { lang, country } = getLangCountry(params);

  const real = getRealLangCountry(params);

  if (
    !SUPPORTED_LANG.includes(real.lang) ||
    !SUPPORTED_COUNTRY.includes(real.country)
  ) {
    return {
      redirect: {
        destination: '/',
        permanent: false
      }
    };
  }

  const [{ data = {}, error = null } = {}, alternates] = await Promise.all([
    getShopContent({ lang, country }),
    fetchAlternateUrls({
      url: '/shop',
      lang,
      country
    })
  ]);

  // TODO remove
  // if (error) {
  //   return { notFound: true };
  // }

  return {
    props: {
      data: error ? { content: [] } : data,
      alternates
    },
    revalidate: 86400
  };
}

export async function getStaticPaths() {
  return {
    paths: LANG_STATIC_PATHS,
    fallback: 'blocking'
  };
}
